export default __webpack_public_path__ + "static/media/social-email.f3b0fa37.svg";